import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

interface LayoutProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

const Layout = ({ title, description, children }: LayoutProps) => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{title}</title>
        {description && <meta name="description" content={description} />}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      {children}
    </HelmetProvider>
  );
};

export default Layout;
